import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_AGGREGATE_DATA, GET_COLLECTION_DATA, SEARCH_COLLECTION_URL} from '../../api';
import $ from "jquery";
import {capitalize} from "../../utils/capitalize";
import cogoToast from "cogo-toast";
import {getFinanceReport, payout} from "../../api/app";
import moment from "moment";
import formatNumber from "../../utils/formatNumber";
import networks from "../../data/networks.json";

let currentDateRange = null;
let total = 0;
let searchableFields = [
    { field: 'status', isNumeric: false },
    { field: 'collector.name', isNumeric: false },
    { field: 'collector.email', isNumeric: false }
]

const Payout = () => {

    document.title = "Payout";

    const [stateReady, setStateReady] = useState(false);
    const [editForm, setEditForm] = useState(false);

    const token = localStorage.getItem('jwtToken');
    const [selectedDate, setSelectedDate] = useState(false);
    const [currDateRange, setCurrDateRange] = useState(null);
    const [reset, setReset] = useState(new Date().getTime());
    const [exportLoading, setExportLoading] = useState(false);
    const [network, setNetwork] = useState([]);

    // useEffect(() => {
    //     let data = currentDateRange !== null ? {
    //         start_date: currentDateRange.start,
    //         end_date: currentDateRange.end
    //     } : {}
    //
    //     getFinanceReport(data).then((response) => {
    //         if(!response.error) {
    //             $('#total-revenue').text(formatNumber(response.payload.total_revenue));
    //             $('#total-disbursed').text(formatNumber(response.payload.total_payout));
    //             $('#total-balance').text(formatNumber((response.payload.total_revenue_online - response.payload.total_commission) - (parseInt(response.payload.total_payout) + parseInt(response.payload.total_transfer_fee))));
    //             $('#total-commission').text(formatNumber(response.payload.total_commission));
    //             $('.current-date').text(response.payload.current_date);
    //         }
    //     });
    // }, [reset]);

    useEffect(() => {
        let table = $('#td-payout').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Payout Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "payout",
                        searchableFields,
                        pageSize: data.start,
                        filter: currentDateRange !== null ? {
                            status: "paid",
                            "date.str":
                                {
                                    $gte: currentDateRange.start,
                                    $lte: currentDateRange.end
                                }
                        } : {status: "paid"},
                        format: 'json',
                        populate: [
                            {
                                model: "grant",
                                path: "doc",
                                populate: {
                                    path: "user",
                                    model: "user"
                                }
                            }
                        ],
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        total = res.total;
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return capitalize(data?.doc?.user?.name);
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return `K${formatNumber(data?.amount)}`;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return capitalize(data?.gateway);
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.date.str).format("Do MMM, YYYY HH:mm")
                    },
                    "targets": 4
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link delete_payout"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.delete_payout', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();
            $(".data-message").text(`Are you sure, you want to delete, ${capitalize(extract_td.raw.collector.name)} payout?`);
            $('#delete-payout').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                payout("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Payout successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        $('#td-payout tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Reference #:</td>' +
                '<td>'+ `${d.raw?.ref_number.toUpperCase() || "No Data"}` +'</td>' +
                '<tr>' +
                '<td>Transaction ID:</td>' +
                '<td>'+ `${d.raw?.metadata?.transaction_id.toUpperCase() || "No Data"}` +'</td>' +
                '</tr>' +
                '<td>Account Number:</td>' +
                '<td>'+ `${d.raw?.metadata?.account_number || "No Data"}` +'</td>' +
                '</tr>' +
                '<td>Network:</td>' +
                '<td>'+ `${d.raw?.metadata?.network || "No Data"}` +'</td>' +
                '</tr>' +
                '</table>'
            );
        }

        return () => {
            currentDateRange = null;
            total = 0;
            table.destroy();
        }

    }, []);

    const handleDateRangeSelect = (range) => {
        const formattedStartDate = $.datepicker.formatDate('dd/mm/yy', range.startDate);
        const formattedEndDate = $.datepicker.formatDate('dd/mm/yy', range.endDate);

        currentDateRange = {
            start: moment(formattedStartDate, 'DD/MM/YYYY').format("YYYY/MM/DD 00:00:00"),
            end: moment(formattedEndDate, 'DD/MM/YYYY').format("YYYY/MM/DD 23:59:59")
        };

        setCurrDateRange({
            start: moment(formattedStartDate, 'DD/MM/YYYY').format("YYYY/MM/DD 00:00:00"),
            end: moment(formattedEndDate, 'DD/MM/YYYY').format("YYYY/MM/DD 23:59:59")
        });

        setSelectedDate(true);

        reloadTable();
    };

    const refreshTable = (e) => {
        e.preventDefault();
        setSelectedDate(false);
        setCurrDateRange(null);
        currentDateRange = null;
        setReset(new Date().getTime());
        $('#td-payout').DataTable().ajax.reload(null, false);
    }

    const reloadTable = () => {
        setReset(new Date().getTime());
        $('#td-payout').DataTable().ajax.reload(null, false);
    };

    const handleShowModal = () => {
        setEditForm(false);
        $('#collector-select2').prop("disabled", false).prop("required", true);
        initializeCollectorSearch();
        $('#payout_form').parsley();
        $("#modalPayout").modal({ backdrop: 'static', focus: false, show: true });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let amount = $('#amount').val();
        let email = $('#email').val();

        setStateReady(true);

        let data = {
            amount,
            email,
            account_number: $('#account-number').val(),
            network: $('#network').val(),
            gateway: $('#gateway').val(),
            collector: $('#collector-select2').val()[0]
        };

        payout("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Data successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalPayout", "payout_form");
                reloadTable();
            }
        });
    }

    const initializeCollectorSearch = () => {
        let modalPayout = $('#modalPayout');
        $('#collector-select2').select2({
            placeholder: 'Select garbage collector or type name',
            allowClear: true,
            width:"100%",
            maximumSelectionLength: 1,
            dropdownParent: modalPayout,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization": token,
                },
                data: function(query) {
                    return {
                        query: query,
                        collection: "collector"
                    };
                },
                processResults: function(data) {
                    return {
                        results: $.map(data, function(item) {
                            return {
                                text: capitalize(item.name),
                                email: item.email,
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $("#email").val(e.params.data.email)
            $(".select2-search__field").css({display: "none"});
        }).on('select2:unselect', function() {
            $("#email").val(null);
            $(".select2-search__field").css({display: "inline-block"});
        });
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const handlePayment = (e) => {
        $("#label-number").text(e.target.value === "momo" ? "Mobile Number" : "Account Number");
        setNetwork(networks.filter((item) => item.type === e.target.value));
        $("#network").val('');
    }

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Payout</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Payout</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Payouts</h6>
                                <div className="d-flex tx-18">
                                    <a href="#" onClick={refreshTable.bind()} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="td-payout" className="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">Amount</th>
                                        <th className="wd-20p">Source</th>
                                        <th className="wd-20p">Date Issued</th>
                                        <th className="wd-20p">Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog"
                 aria-labelledby="confirmation" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div className="modal-content tx-14">
                        <div className="modal-header">
                            <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="mg-b-0 data-message">Empty</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="delete-payout" className="btn btn-success btn-block">Yes,
                                Delete
                            </button>
                            <button type="button" className="btn btn-danger btn-block mt-0"
                                    data-dismiss="modal">Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Payout;
